import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '@zola/zola-ui/src/styles/emotion';

import {
  Accordion,
  AccordionBody,
  AccordionButton,
  AccordionSection,
  AccordionSectionHeading,
} from '@zola/zola-ui/src/components/AccordionV2/AccordionV2.styles';
import {
  SideDrawerHeaderContainer,
  SideDrawerFooterContainer,
} from '@zola/zola-ui/src/components/SideDrawer';
import {
  RadioFieldWrapper,
  StyledLabel,
} from '@zola/zola-ui/src/components/Form/RadioFieldV2/RadioField/RadioFieldV2.styles';

export const PLPMobileControlsHeader = styled(SideDrawerHeaderContainer)`
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  margin: ${SPACING.S24} ${SPACING.MD};
`;

export const HeaderTxt = styled.h3`
  font-size: ${FONT.SIZE.LARGE};
  line-height: 30px;
  color: ${COLORS3.BLACK_100};
  margin: 0;
  letter-spacing: -1.2px;
`;

export const PLPMobileControlsContainer = styled.div`
  border-top: 1px solid ${COLORS3.BLACK_030};
`;

export const PLPMobileControlsInnerContainer = styled.div`
  padding: 0 ${SPACING.MD};

  ${Accordion} {
    ${AccordionSection} {
      border-bottom-color: ${COLORS3.BLACK_015};
      padding: 0;
    }

    ${AccordionBody} {
      max-height: 300px;
      overflow-y: auto;

      ${MEDIA_QUERY.MOBILE} {
        max-height: 100px;
      }
    }

    ${AccordionSection}:first-of-type {
      border-top: none;
    }

    ${AccordionButton} {
      text-align: unset;
      align-items: flex-start;
      text-decoration: none !important;
      padding: ${SPACING.S16} 0;
      align-items: center;

      &:hover,
      &:focus,
      &:active {
        text-decoration: none !important;
      }
    }

    ${AccordionSectionHeading} {
      text-decoration: none !important;

      &:hover,
      &:focus,
      &:active {
        text-decoration: none !important;
      }
    }
  }
`;

export const FilterSortHeader = styled.span`
  ${FONT.textSizeRegular(FONT.SIZE.SMALL)}
  font-weight: ${FONT.WEIGHT.MEDIUM};
  margin: 0 0 ${SPACING.XXS} 0;
  padding: 0;
  color: ${COLORS3.BLACK_100};
  display: block;
`;

export const FilterSortSubheader = styled.span`
  ${FONT.textSizeRegular(FONT.SIZE.SMALL)}
  color: ${COLORS3.BLACK_050};
  display: block;
  font-weight: ${FONT.WEIGHT.REGULAR};
  margin: 0;
  overflow-x: auto;
  padding-right: ${SPACING.S16};
  padding: 0;
  white-space: nowrap;
  width: 225px;
`;

export const PLPMobileControlsFooter = styled(SideDrawerFooterContainer)`
  border: none;
  box-shadow: none;

  border-top: 1px solid ${COLORS3.BLACK_030};
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACING.SM} ${SPACING.MD} ${SPACING.SM} 60px;

  a {
    ${FONT.textSizeUltraCompact(FONT.SIZE.SMALLER)}
  }

  button {
    font-weight: ${FONT.WEIGHT.MEDIUM};
  }
`;

export const RadioFieldsContainer = styled.div`
  ${RadioFieldWrapper}:not(:last-of-type) {
    margin-bottom: ${SPACING.S24};
  }

  ${StyledLabel} {
    &::before {
      margin-right: ${SPACING.SM};
    }
  }
`;

export const CheckboxesContainer = styled.div`
  .zola-ui.v2-render-checkbox-field:not(:last-of-type) {
    margin-bottom: ${SPACING.S24};

    label {
      margin-right: ${SPACING.SM};
    }
  }
`;
